import { render, staticRenderFns } from "./rollerpressStyle.vue?vue&type=template&id=062989f9&"
import script from "./rollerpressStyle.vue?vue&type=script&lang=js&"
export * from "./rollerpressStyle.vue?vue&type=script&lang=js&"
import style0 from "./rollerpressStyle.vue?vue&type=style&index=0&id=062989f9&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports